import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import Path from 'routes/path'

export const ReceiptHeader = ({ transactionDate }) => (
  <StyledReceiptHeader>
    <a href={Path.home()}>
      <img
        alt="SPACEMARKET"
        src="//cdnspacemarket.com/images/email/logo_business.png"
        width="194px"
      />
    </a>
    <StyledDateText>
      取引年月日：{moment(transactionDate).format('YYYY年MM月DD日')}
    </StyledDateText>
  </StyledReceiptHeader>
)

const StyledReceiptHeader = styled.div`
  padding: 12px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
`
const StyledDateText = styled.p`
  font-size: 14px;
  margin-left: auto;
`
